import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";
// Types
import Reducers from "app/types/Reducers";
import { Dimension } from "./ManagementBillingUsage.types";
// Models
import { IState, IUsage } from "./ManagementBillingUsage.models";
// Async
import { getUsage } from './ManagementBillingUsage.async';

const initialState:IState = {
  usages: [],
  params: {
    dimensions: Dimension.Service,
    accountId: null,
    serviceId: null,
    subscriptionPackageId: null,
    "period.start": dayjs().startOf('month'),
    "period.end": dayjs()
  }
};

const slice = createSlice({
  name: Reducers.ManagementBillingUsage,
  initialState,
  reducers: {
    setParams: (state, action:PayloadAction<any>) => {
      const params = action.payload;
      state.params = Object.keys(state.params).reduce((acc:any, cur:any) => {
        acc[cur] = (state.params as any)[cur];
        if ( typeof params[cur] !== 'undefined' ) acc[cur] = params[cur];
        return acc;
      }, {});
    },
    // Default
    setInitialField: <IStateKey extends keyof IState>(state: IState, action: PayloadAction<IStateKey>) => {
      state[action.payload] = initialState[action.payload];
    }
  },
  extraReducers(builder) {
    // Get subscriptions
    builder.addCase(getUsage.pending, (state) => {
      state.usages = [];
    });
    builder.addCase(getUsage.fulfilled, (state, action:PayloadAction<IUsage[]>) => {
      state.usages = action.payload;
    });
  },
});

export const ManagementBillingUsageActions = slice.actions;

export default slice.reducer;
